import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-service-administration',
  templateUrl: './view-service-administration.component.html',
  styleUrls: ['./view-service-administration.component.scss']
})
export class ViewServiceAdministrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
